import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { AppConfig } from "../Utilities/app-config.service";
import { Message } from "../models/message";
import { HelperService } from './helper.service';
import { ResultStatus } from '../models/result-status';

@Injectable({
  providedIn: "root",
})
export class MessageCenterService {
  constructor(
    private apiService: ApiService,
    private appConfig: AppConfig,
    private helperService: HelperService
    ) {}

  getMessages() {
    return this.apiService.get(this.appConfig.GetUrl("getMessages"));
  }

  getMessagesById(id: number) {
    return this.apiService.get(
      this.appConfig.GetUrl("getMessageById").replace("[MESSAGEID]", id)
    );
  }

  deleteMessage(id: number) {
    return this.apiService.delete(
      this.appConfig.GetUrl("deleteMessageById").replace("[MESSAGEID]", id)
    );
  }

  getReceiptFilter() {
    return this.apiService.get(this.appConfig.GetUrl("getRecipientFilter"));
  }

  sendMessage(message: Message) {
    if ( this.helperService.isUndefinedOrNullOrEmpty(message.ID)) {
      return this.apiService.post(this.appConfig.GetUrl("createMessageSchedule"), message);
    } else {
      return this.apiService.put(this.appConfig.GetUrl("updateMessageSchedule"), message);
    }
  }

  readMessage(id) {
    return this.apiService.put(
      this.appConfig.GetUrl("readInboxMessage").replace("[MESSAGEID]", id)
    );
  }

  getInboxCount() {
    return this.apiService.get(this.appConfig.GetUrl("getInboxCount"));
  }

  updateInboxCount() {
    this.getInboxCount().subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.appConfig.SharedComponent.inboxCount = result.Data;
      } else {
        this.appConfig.SharedComponent.inboxCount = 0;
      }
    });
  }
}
